import { EventEmitterBaseService } from "./../event-emitter-service/event-emitter.service";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { retornaUrlComParametros } from "src/app/share/tools/retorna-url-parametros-tools";
import { urlApi } from "src/environments/environment";
import { SituacaoNotificacaoEnum } from "../../enum/situacao-notificacao-enum";
import { ParametrosChaveValorModel } from "../../model/parametros-chave-valor-model";
import { NotificacaoRecepcaoRequest } from "../../request/notificacoes-signalR/notificacoes-recepcao-request";
import { ResponseBase } from "../../response/base/response-base";
import { NotificacaoResponse } from "../../response/notificacoes-signalR/notificacoes-response";
import { NotificacoesRetornoResponse } from "../../response/notificacoes-signalR/notificacoes-retorno-response";
import { SignalRService } from "../SignalR/SignalR.service";
import { ToastrService } from "ngx-toastr";
import { BpToastComponent } from "src/app/share/component/bp-toast/bp-toast.component";
import { NotificacaoTipoEnum } from "../../enum/notificacao-tipo-enum";
import { SessionService } from "../session/session.service";
import { CognitoService } from "../cognito/cognito.service";
import { FactoryService } from "../factory/factory.service";
import { HttpService } from "src/app/services/http.service";
@Injectable({
  providedIn: "root",
})
export class NotificacoesHubService extends SignalRService {
  public notificacoesRecebidas = new NotificacoesRetornoResponse();

  constructor(
    private httpService: HttpService,
    private toastr: ToastrService,
    private router: Router,
    private session: SessionService,
    private cognito: CognitoService,
    private factory: FactoryService
  ) {
    super();
  }

  public async startHub(): Promise<void> {
    if (this.hubClient) {
      return;
    }
    this.configurarHub("notificacaoHub");
    await this.hubClient
      .start()
      .then(() => {
        this.hubClient.invoke(
          "AddGrupoBilhetagem",
          this.session.getUserSession().id
        );
        this.escutarAtualizacaoNotificacoes();
        this.obterNotificacoes();
        this.escutarRecebimentoNotificacoes();
      })
      .catch((e) => {
        console.log(e.message);
      });
  }

  private escutarAtualizacaoNotificacoes() {
    this.hubClient.on(
      "ObterNotificacoesBilhetagem",
      (resp: NotificacoesRetornoResponse) => {
        if (resp.listaNotificacoesUltimos7Dias) {
          resp.listaNotificacoesUltimos7Dias =
            resp.listaNotificacoesUltimos7Dias.sort((obj1, obj2) =>
              obj1.dataHoraCriacao > obj2.dataHoraCriacao ? -1 : 1
            );
        }
        if (resp.listaNotificacoesDemaisDias) {
          resp.listaNotificacoesDemaisDias =
            resp.listaNotificacoesDemaisDias.sort((obj1, obj2) =>
              obj1.dataHoraCriacao > obj2.dataHoraCriacao ? -1 : 1
            );
        }
        this.notificacoesRecebidas = resp;
      }
    );
  }

  private async obterNotificacoes() {
    const url = "/Notificacao/ObterNotificacoesBilhetagem";
    let params = new HttpParams();
    params = params.append("usuarioId", this.session.getUserSession().id);
    const options = await this.factory.defaultHttpHeaders(params);

    await this.httpService
      .get(url, options)
      .then((resp: ResponseBase<NotificacoesRetornoResponse>) => {
        if (
          resp.data.listaNotificacoesDemaisDias ||
          resp.data.listaNotificacoesUltimos7Dias
        ) {
          this.tratarNotificacoesObtidas(resp.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  private async escutarRecebimentoNotificacoes() {
    await this.hubClient.on("Notificar", (resp: NotificacaoResponse) => {
      this.tratarNotificacoesUnicas(resp);
    });
  }

  private tratarNotificacoesUnicas(resp: NotificacaoResponse) {
    this.notificacoesRecebidas.listaNotificacoesUltimos7Dias.push(resp);
    this.notificacoesRecebidas.quantidadeNaoVisualizadas++;
    this.atualizarNotificacoesPorSituacao(
      SituacaoNotificacaoEnum.enviada,
      SituacaoNotificacaoEnum.recebida
    );
    switch (resp.tipo) {
      case NotificacaoTipoEnum.decisaoManualCobranca:
        this.showNotificacaoDecisaoManualCobranca(resp.notificacaoId);
        break;

      default:
        this.toastr
          .info("Clique aqui e confira", "Nova notificação")
          .onTap.subscribe(() => {
            EventEmitterBaseService.get("openNotificationsModal").emit();
          });
        break;
    }
  }

  private tratarNotificacoesObtidas(resp: NotificacoesRetornoResponse) {
    resp.listaNotificacoesUltimos7Dias =
      resp.listaNotificacoesUltimos7Dias.sort((obj1, obj2) =>
        obj1.dataHoraCriacao > obj2.dataHoraCriacao ? -1 : 1
      );
    resp.listaNotificacoesDemaisDias = resp.listaNotificacoesDemaisDias.sort(
      (obj1, obj2) => (obj1.dataHoraCriacao > obj2.dataHoraCriacao ? -1 : 1)
    );
    this.notificacoesRecebidas = resp;
    this.atualizarNotificacoesPorSituacao(
      SituacaoNotificacaoEnum.enviada,
      SituacaoNotificacaoEnum.recebida
    );
  }

  public async atualizarNotificacoesPorSituacao(
    situacaoInicial: SituacaoNotificacaoEnum,
    situacaoFinal: SituacaoNotificacaoEnum
  ) {
    const notificacoesParaAtualizar = new NotificacoesRetornoResponse();
    notificacoesParaAtualizar.listaNotificacoesUltimos7Dias =
      this.notificacoesRecebidas.listaNotificacoesUltimos7Dias.filter(
        (x) => x.situacao === situacaoInicial
      );

    notificacoesParaAtualizar.listaNotificacoesDemaisDias =
      this.notificacoesRecebidas.listaNotificacoesDemaisDias.filter(
        (x) => x.situacao === situacaoInicial
      );

    const atualizarNotificacoesRecebidas = new NotificacaoRecepcaoRequest();
    atualizarNotificacoesRecebidas.listaNotificacoesId = [];

    notificacoesParaAtualizar.listaNotificacoesUltimos7Dias.forEach((nots) => {
      atualizarNotificacoesRecebidas.listaNotificacoesId.push(
        nots.notificacaoId
      );
    });
    notificacoesParaAtualizar.listaNotificacoesDemaisDias.forEach((nots) => {
      atualizarNotificacoesRecebidas.listaNotificacoesId.push(
        nots.notificacaoId
      );
    });

    atualizarNotificacoesRecebidas.situacao = situacaoFinal;
    atualizarNotificacoesRecebidas.dataHoraAtualizacao = new Date();
    atualizarNotificacoesRecebidas.usuarioId = this.session.getUserSession().id;
    if (atualizarNotificacoesRecebidas.listaNotificacoesId.length > 0) {
      await this.hubClient.invoke(
        "AtualizarNotificacoesBilhetagem",
        atualizarNotificacoesRecebidas
      );
    }
  }

  private showNotificacaoDecisaoManualCobranca(notificacaoId: number) {
    this.toastr
      .show(
        `<p><b>Análise de semelhança:</b></p>

      <p>Necessária atuação para realização de cobrança manual.</p>

      <p><b>Clique aqui </b> para visualizar</p>`,
        null,
        {
          toastComponent: BpToastComponent,
          disableTimeOut: true,
        }
      )
      .onTap.subscribe(() => {
        this.router.navigate(["/debito-manual-similaridade"]);
        const atualizarNotificacoesRecebidas = new NotificacaoRecepcaoRequest();
        atualizarNotificacoesRecebidas.listaNotificacoesId = [];
        atualizarNotificacoesRecebidas.listaNotificacoesId.push(notificacaoId);
        atualizarNotificacoesRecebidas.situacao =
          SituacaoNotificacaoEnum.visualizada;
        atualizarNotificacoesRecebidas.dataHoraAtualizacao = new Date();
        atualizarNotificacoesRecebidas.usuarioId =
          this.session.getUserSession().id;
        this.hubClient.invoke(
          "AtualizarNotificacoesBilhetagem",
          atualizarNotificacoesRecebidas
        );
      });
  }
}
